import { FlowStepEditor } from "../FlowStepEditor";
import { ExpressionEditUI } from "./ExpressionEditUI";
import React from "react";
import { RunExpression } from "../../../rule-engine-core/Flow/Steps/Expressions/RunExpression";

export class RunExpressionEditor extends FlowStepEditor<RunExpression> {
    renderEditUI(): JSX.Element | null {
        return <ExpressionEditUI expression={this.stepData.expression} />;
    }
}
